import { render, staticRenderFns } from "./ImportStructDlg.vue?vue&type=template&id=476f99ed&"
import script from "./ImportStructDlg.vue?vue&type=script&lang=js&"
export * from "./ImportStructDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports